import { render } from "./PurchaseReturnDetails.vue?vue&type=template&id=a87c5030"
import script from "./PurchaseReturnDetails.vue?vue&type=script&lang=js"
export * from "./PurchaseReturnDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__